export const RatingStar =
  'M11,0.7C11.2,0.2,11.6,0,12,0s0.8,0.2,1,0.7l2.8,6C16,' +
  '7,16.3,7.3,16.7,7.3l6.4,1c0.4,0.1,0.8,0.4,0.9,0.8s0,' +
  '0.9-0.3,1.2L19.1,15c-0.2,0.2-0.4,0.7-0.3,1l1.1,6.6c0.1,' +
  '0.4-0.1,0.9-0.4,1.1c-0.4,0.2-0.8,0.3-1.2,0.1l-5.7-3.1c-0.3-0.2-0.7-0.2-1,' +
  '0l-5.7,3.1C5.5,24,5,24,4.7,23.8c-0.4-0.2-0.5-0.7-0.4-1.1l1-6.7c0.1-0.4-0.1-0.8-0.4-1' +
  'l-4.6-4.7C0,10-0.1,9.6,0,9.1s0.5-0.7,0.9-0.8l6.4-1c0.4,0,0.7-0.2,0.8-0.6L11,0.7z';
